/* ==========================================================================
   BANGTALK GUIDES — FAQ accordion
   Event-delegated, so any number of guides can render on one page without the
   listener collisions the old per-article inline scripts caused. Replaces the
   copy of this script that used to sit in every guide body.
   ========================================================================== */
(function () {
  'use strict';

  function closeAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('.bt-faq-ans.open'), function (a) {
      a.classList.remove('open');
    });
    Array.prototype.forEach.call(scope.querySelectorAll('.bt-faq-btn.open'), function (b) {
      b.classList.remove('open');
      b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.bt-faq-btn');
    if (!btn) return;

    var ans = btn.nextElementSibling;
    if (!ans || !ans.classList.contains('bt-faq-ans')) return;

    e.preventDefault();

    // Scope to this guide so two guides on one page stay independent.
    var scope = btn.closest('.bt') || document;
    var wasOpen = ans.classList.contains('open');

    closeAll(scope);

    if (!wasOpen) {
      ans.classList.add('open');
      btn.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.bt-faq-btn'), function (b) {
      if (!b.hasAttribute('type')) b.setAttribute('type', 'button');
      b.setAttribute('aria-expanded', b.classList.contains('open') ? 'true' : 'false');
    });
  });
})();
